import namespace from './namespace';

export default  {
    [namespace.getters.TFS_VALUES]: (state) => {
        if (state[namespace.state.AVAILABLE_TFS_VALUES] === undefined) {
            return [];
        }
        return Object.values(state[namespace.state.AVAILABLE_TFS_VALUES])
                     .filter(value => !value.Hidden)
                     .sort(sortByValue);
    },

    [namespace.getters.JIRA_VALUES]: (state) => {
        if (state[namespace.state.AVAILABLE_JIRA_VALUES] === undefined) {
            return [];
        }
        return Object.values(state[namespace.state.AVAILABLE_JIRA_VALUES])
                     .filter(value => !value.Hidden)
                     .sort(sortByValue);
    },
    [namespace.getters.MAPPINGS_GROUPS]: (state, getters) => {
        return state[namespace.state.MAPPINGS_GROUPS];
    },  
    [namespace.getters.IS_LOADER_VISIBLE]: (state) => {
        return state[namespace.state.LOADER_VISIBLE];
    },
    [namespace.getters.SELECTED_JIRA_FIELD]:(state) => {
        return state[namespace.state.SELECTED_JIRA_FIELD];
    },
    [namespace.getters.SELECTED_TFS_FIELD]:(state) => {
        return state[namespace.state.SELECTED_TFS_FIELD];
    }
};

const sortByValue = function(a, b) {
  var valueA = a.Value.toUpperCase();
  var valueB = b.Value.toUpperCase(); 
  if (valueA < valueB) {
    return -1;
  }
  if (valueA > valueB) {
    return 1;
  }
  return 0;
}


// WEBPACK FOOTER //
// ./src/store/modules/fieldsMapping/getters.js